import styled from "styled-components";

export const PaginationStyled = styled.div`
  display: flex;
  justify-content: center;
  margin: 40px auto;
`;
